import React, { useEffect } from "react";
import ProductFilters from "./components/ProductFilters";
import ProductList from "./components/ProductList";
import Pagination from "../MyAccount/components/Pagination";
import SEO from "../../components/SEO";
import useProduct from "../../hooks/useProduct";

const Products = () => {
  const { setHasVideo, products } = useProduct();

  // Desativa o filtro de vídeo quando acessa a página de produtos normal
  useEffect(() => {
    setHasVideo(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Executa apenas uma vez na montagem

  // Structured Data - ItemList para lista de produtos
  useEffect(() => {
    if (!products || products.length === 0) return;

    let itemListScript = document.querySelector('script[data-jsonld="itemlist-products"]');
    if (!itemListScript) {
      itemListScript = document.createElement("script");
      itemListScript.setAttribute("type", "application/ld+json");
      itemListScript.setAttribute("data-jsonld", "itemlist-products");
      document.head.appendChild(itemListScript);
    }

    const itemListSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Catálogo de Produtos - Grupo Terra",
      description: "Catálogo completo com mais de 7 mil produtos para mecânica pesada",
      numberOfItems: products.length,
      itemListElement: products.slice(0, 20).map((product, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Product",
          name: product.product_name,
          url: `${window.location.origin}/produto/${product.id}`,
          image: product.image,
          sku: product.product_id?.toString(),
        },
      })),
    };

    itemListScript.textContent = JSON.stringify(itemListSchema);

    return () => {
      const script = document.querySelector('script[data-jsonld="itemlist-products"]');
      if (script) script.remove();
    };
  }, [products]);

  return (
    <>
      <SEO 
        title="Produtos - Catálogo Completo | Grupo Terra"
        description="Explore nosso catálogo com mais de 7 mil produtos para mecânica pesada: ferramentas profissionais, fixadores, produtos químicos e muito mais. Encontre o que precisa para sua oficina."
        keywords="produtos mecânica pesada, catálogo ferramentas, fixadores, químicos, produtos automotivos, estoque"
      />
      <div className="container">
        <div style={{ marginBottom: "30px" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>Catálogo de Produtos</h1>
          <p style={{ color: "#666", fontSize: "1.1rem" }}>Explore nosso catálogo completo com mais de 7 mil produtos para mecânica pesada</p>
        </div>
        <div className="row row-cols-lg-2 row-cols-sm-1">
          <ProductFilters />
          <ProductList />
        </div>
      <div
        style={{
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Pagination />
      </div>
    </div>
    </>
  );
};
export default Products;
